import posthog from 'posthog-js'
import { getLogtoInstance } from './useLogTo'

export function useAuth() {
  const { signIn, signOut, isAuthenticated, isLoading, getAccessToken, getIdTokenClaims } = getLogtoInstance()

  const login = async (forceLogin = false): Promise<void> => {
    if (!isAuthenticated.value || forceLogin) {
      sessionStorage.setItem('postLoginRedirect', window.location.pathname + window.location.search + window.location.hash)
      const params = new URLSearchParams(window.location.search)
      const invite = params.get('invite')

      const options: any = {
        redirectUri: import.meta.env.VITE_SIGN_IN_PAGE,
      }

      if (invite) {
        options.extraParams = { login_hint: invite }
      }

      signIn(options)
    }
  }

  const logout = async (): Promise<void> => {
    posthog.reset()
    signOut(`${window.location.origin}/`)
  }

  const fetchActualUser = async () => {
    if (isAuthenticated.value) {
      return await getIdTokenClaims()
    }
  }

  const getToken = async () => {
    if (!isAuthenticated.value) {
      return null
    }
    const resource = import.meta.env.VITE_AUTH_TICKETS_RESOURCE

    return await getAccessToken(resource)
  }

  return {
    login,
    logout,
    isAuthenticated,
    isLoading,
    fetchActualUser,
    getToken,
  }
}
